import vi from './vi.json'
export default class languageSDK {
    static language = vi
    static loadLanguageByJson = (jsonLanguage) =>{
        this.language = jsonLanguage
    }
}